<template>
  <div class="payment-summary">
    <Navbar />
        <div class="mt-5 pt-5 kova-width">
            <div class="text-left pl-0 pl-md-5 mt-3 ml-5 mb-4"><a-icon class="mr-1" type="arrow-left" /> <span class="go-back" @click="goBack">Go Back</span></div>
            <div class="px-1 px-md-4 px-lg-5 mx-lg-4 my-5">
            <div class="bg-light border p-2 p-md-4">
                <h5 class="font-weight-bolder text-left">Billing and Payments</h5>
                <h6 class="text-left mt-4">Current Balance</h6>
                <h6 class="font-weight-bolder text-left">Your balance is $120.00</h6>
            </div>
            <div class="mx-3 add-rounded">
                <div class="row">
                    <div class="col-12 col-md-12 col-lg-7">
                        <div class="row">
                            <div class="col-12 col-md-12 col-lg-11 bg-light border border-top-0">
                                <div class="my-4">
                                    <div class="d-flex">
                                        <div class="text-left mr-auto"><h6 class="font-weight-bolder text-left ml-3">Card</h6> </div>
                                        <div class="">
                                            <div class="input-group mb-3">
                                                <input type="button" value="Add a new bank" class="btn-kovatek new-bank py-1 px-3" />
                                                <div class="input-group-append btn-kovatek plus-btn-icon py-1 px-2">
                                                    <a-icon type="plus" style="position: relative;bottom: -3px;"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="px-1 px-md-3 ">
                                        <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Card Holder Name</h6>
                                        <a-input size="large" class="ml-1 font-weight-bolder" v-model="cardName" />
                                        <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font" >Card Number</h6>
                                        <a-input size="large" class="ml-1 font-weight-bolder" v-model="cardNumber" />
                                        <!-- <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Bank Name</h6>
                                        <a-input size="large" class="ml-1 font-weight-bolder" v-model="bankName"/> -->
                                        <div class="d-flex">
                                        <div>
                                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Expiry Date</h6>
                                            <a-input size="large" type="date" class="ml-1 font-weight-bolder" v-model="date" required/>
                                            </div>
                                            <div class="ml-3">
                                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font" >CVC</h6>
                                            <a-input size="large" class="ml-1 font-weight-bolder" v-model="cvc" required/>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="col-12 col-md-12 col-lg-1 bg-white"></div>
                        </div>
                    </div>

                    <div class="col-12 col-md-12 col-lg-5 bg-light border border-top-0">
                        <div class="px-1 px-md-3">
                            <h6 class="font-weight-bolder text-left mt-4">Project Summary</h6>
                            <h5 class="font-weight-lighter text-left ml-2 mt-5">Milestone</h5>
                            <a-input size="large" v-model="projectMile" class="ml-1 font-weight-bolder" disabled />
                            <div class="text-left mt-2">
                                <span class="py-1 px-2 rounded ctrl-font" style="background-color: #ededed">Monday, 20th of January, 2020</span>

                            </div>
                            <div class="d-flex mt-3">
                                <h6 class="font-weight-bolder mr-auto ml-3">Bill</h6>
                                <a-input size="large" v-model="bill" class="ml-1 font-weight-bolder" style="width: 120px" disabled />
                            </div>
                            <div class="d-flex mt-3">
                                <h6 class="font-weight-bolder mr-auto ml-3">Charges</h6>
                                <h5 class="font-weight-bolder">$50</h5>

                            </div>
                            <div class="d-flex mt-3">
                                <h6 class="font-weight-bolder mr-auto ml-3 kova-text">Total</h6>
                                <h5 class="font-weight-bolder kova-text">${{bill + (bill * 0.07)}}</h5>

                            </div>
                        </div>
                        <div class="d-flex my-4 px-lg-3 justify-content-end">
                            <span class="py-2 px-3 kova-bg text-white rounded font-weight-bolder ctrl-font pointer" style="white-space:nowrap" @click="showModal">Deposit Payment</span>
                            <span class="font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer">Cancel</span>
                        </div>
                        
                    </div>
                </div>
            </div >
            
        </div>
    </div>

        <div class="">
            <a-modal v-model="visible" onOk="handleOk" width="750px" centered>
            <template slot="footer">
                <div class="d-flex">
                    <button key="submit" @click="handleOk" class="btn-kovatek add-rounded px-5 py-2 mr-auto">Yes</button>
                    <button key="back" @click="handleCancel" class="btn-outline-kovatek add-rounded px-5 py-2">No</button>
                </div>
                
            </template>
            <h3 class="font-weight-bolder kova-text text-center my-3">Release $210 to Johnson K?</h3>
            </a-modal>
        </div>
        <div class="">
            <a-modal v-model="paymentSent" onOk="cancel" width="750px" centered>
            <template slot="footer">
                <div class="">
                    <button key="back" @click="cancel" class="btn-kovatek add-rounded px-5 py-2 mr-auto">Ok</button>
                </div>
                
            </template>
            <h3 class="kova-text text-center my-3">Payment Sent <font-awesome-icon icon="check-circle" style="font-size: 30px"></font-awesome-icon> </h3>
            </a-modal>
        </div>
    <Footer />
  </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'payment-summary',
  components: {
   Navbar, Footer
  },
  data(){
      return {
        cardName: "Johnson Kolawole",
        cardNumber: "5222 4299 8040 8856",
        bankName: "United Bank for Africa",
        expireDate: Date,
        cvc: 235,
        projectMile: "Login Setup",
        bill: 28000,
        dir: 'down',
        dirState: false,
        visible: false,
        loading: false,
        paymentSent: false,
      }
  },
  methods: {
        goBack(){
                this.$router.go(-1)
            },
        changeCtrl(){
            this.dirState = !this.dirState;
            if(this.dirState){
                this.dir = 'up';
            }else{
                this.dir = 'down';
            }
        },
        showModal() {
            this.visible = true;
        },
        handleOk() {
            this.loading = true;
            setTimeout(() => {
            this.visible = false;
            this.loading = false;
            this.paymentSent = true
            }, 1500);
        },
        handleCancel() {
            this.visible = false;
        },
        cancel(){
            this.paymentSent = false
        }
  }
}
</script>

<style scoped>
.kova-width{
    max-width: 1350px;
    margin:auto
}
.new-bank{
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}
.plus-btn-icon{
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border-left: solid 1px #fff;
}
.ctrl-font{
    font-size: 12px;
}
</style>
